export enum SessionStorageConstants {
    GoogleClassRoomCourses = 'google-classroom-courses',
    GoogleClassRoomCourse = 'google-classroom-course',
    GoogleClassRoomCourseStudents= 'google-classroom-course-students'
}